import { h } from 'preact';
import { createPortal } from 'preact/compat';
import PromoBar from '../promo-bar/promo-bar';
import HeaderTop from './header-top';

const promoContainer = document.getElementById('promo-bar-container');

const HeaderPromo = ({ onlyIcons, customer, promoBar, giftCardEnabled }) =>
  createPortal(
    <div
      style={{ background: promoBar.background }}
      className="hidden md:block relative z-40"
    >
      <div className="!flex tablet:container mx-auto px-24 tablet:px-56 items-center gap-24">
        <div className="flex-1 min-w-0 py-10">
          <PromoBar
            slideClass="justify-center tablet:justify-start gap-12 [&_.content]:truncate [&_.content>p]:inline [&_.btns]:gap-12"
            {...promoBar}
          />
        </div>
        <HeaderTop
          customer={customer}
          onlyIcons={onlyIcons}
          containerClass={'gap-50 hidden tablet:flex py-6'}
          giftCardEnabled={giftCardEnabled}
        />
      </div>
    </div>,
    promoContainer,
  );

export default HeaderPromo;
